function mergeProps(...items) {
    const ret = {};
    items.forEach((item) => {
        if (item) {
            Object.keys(item).forEach((key) => {
                if (item[key] !== undefined) {
                    ret[key] = item[key];
                }
            });
        }
    });
    return ret;
}
export default mergeProps;
